import Head from 'next/head'
import { Header, Footer } from '../front'

function Layout({ children, description = '', title = 'فروشگاه اینترنتی کاج استور', menu, about }) {
    return (
        <>
            <Head>
                <title>{title}</title>
		<meta name="description" content={description} />
		<script async defer data-website-id="619a9903-e5c0-462a-9e8a-b8d68788b542" src="https://afrahub.ir/umami.js"></script>
            </Head>
            <Header menu={menu}></Header>
            {children}
            <Footer about={about}></Footer>
        </>
    )
}

export { Layout }
